import  { ChangeHistory } from '../../../../assets/js/modules/changeHistory';

export default class OffersChangeHistory{
    constructor(){
        this.changeHistoryContainer = document.querySelector('#change-history-container-offers');
        if(!this.changeHistoryContainer) return;
        this.event();   
    }
    event(){
        if (this.changeHistoryContainer) {
            const modelName = 'offers';
            const objectId = offersIdVar;
            const fieldsToShow = ['designation_number', 'status', 'amount'];
            const fieldLabels = {
                designation_number: 'Bezeichnungsnummer',
                status: 'Status',
                amount: 'Betrag'
            };
            const changeHistory = new ChangeHistory(modelName, objectId);
            changeHistory.renderChanges('change-history-container-offers', fieldsToShow, fieldLabels);
        }
    }
}